import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import config from '../../config';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  NamedLink,
  CriteoSales,
} from '../../components';
import { TopbarContainer } from '../../containers';

import css from './styles.css';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { parse } from "../../util/urlHelpers";

const CongratMultiBookingPageComponent = (props) => {
  const { intl, scrollingDisabled, location, currentUser, price } = props;
  const { search } = location;
  const { isMultiBooking = false } = parse(search);
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'CongratMultiBookingPage.schemaTitle' }, { siteTitle });
  const content = intl.formatMessage({ id: isMultiBooking ? 'CongratMultiBookingPage.content' : 'CongratPurchaseBooking.content' }, { provider: intl.formatMessage({ id: 'CongratPurchaseBooking.provider' })});
  const details = intl.formatMessage({ id: isMultiBooking ? 'CongratMultiBookingPage.details' : 'CongratPurchaseBooking.details' });

  const getRedirectLink = () => {
    const redirectLinkProps = ({
      name: 'ReservationsBasePage',
    });

    return (
      <NamedLink {...redirectLinkProps}>
        <FormattedMessage id="word.here"/>
      </NamedLink>
    );
  };

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      {/*<CriteoSales currentUser={currentUser} poolId={id} price={price} />*/}
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CongratMultiBookingPage"/>
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <div className={css.root}>
            <div className={css.container}>
              <h1>
                {content}
              </h1>
              <h3>
                {details}
                {getRedirectLink()}.
              </h3>
            </div>
          </div>
        </LayoutWrapperMain>
      </LayoutSingleColumn>
    </Page>
  );
};

CongratMultiBookingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CongratMultiBookingPage = compose(
  connect(mapStateToProps),
  injectIntl,
)(CongratMultiBookingPageComponent);


export default CongratMultiBookingPage;
